import React from 'react';
import TextField from '../../inputs/text-field/TextField';
import DropDown from '../../inputs/dropdown/Dropdown';
import styles from './TripsCalculator.module.scss';
import { useTranslation } from 'react-i18next';

const TripsCalculator = () => {
  const flightTypes = [
    { value: 'domestic', label: 'Domestic' },
    { value: 'international', label: 'International' },
  ];

  const flightClasses = [
    { value: 'economy', label: 'Economy' },
    { value: 'business', label: 'Business' },
    { value: 'first', label: 'First Class' },
  ];

  const fuelTypes = [
    { value: 'petrol', label: 'Petrol' },
    { value: 'diesel', label: 'Diesel' },
    { value: 'electric', label: 'Electric' },
  ];

  const countries = [
    { value: 'USA', label: 'USA' },
    { value: 'Pakistan', label: 'Pakistan' },
    // Add more countries as needed
  ];

  const { t } = useTranslation();

  return (
    <form className={styles.tripsCalculatorForm}>
      {/* 1. Your Flight */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.tripsCalculator.flightSectionHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.tripsCalculator.flightSectionParagraph')}</p>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.tripsCalculator.passengersLabel')}
            name='passengers'
            type='number'
            placeholder='Enter number'
          />
          <DropDown
            label={t('calculatorView.tripsCalculator.flightTypeLabel')}
            name='flightType'
            option={flightTypes}
          />
        </div>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.tripsCalculator.flightClassLabel')}
            name='flightClass'
            option={flightClasses}
          />
          <TextField
            label={t('calculatorView.tripsCalculator.departureAirportLabel')}
            name='departureAirport'
            placeholder='Enter airport'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.tripsCalculator.arrivalAirportLabel')}
            name='arrivalAirport'
            placeholder='Enter airport'
          />
        </div>
      </div>

      {/* 2. Your Travel in Car */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.tripsCalculator.carTravelSectionHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.tripsCalculator.carTravelSectionParagraph')}</p>
        <div className={styles.inputGroup}>
          <DropDown label={t('calculatorView.tripsCalculator.fuelTypeLabel')} name='fuelType' option={fuelTypes} />
          <DropDown label={t('calculatorView.tripsCalculator.countryLabel')} name='country' option={countries} />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.tripsCalculator.distanceLabel')}
            name='distance'
            type='number'
            placeholder='Enter distance'
          />
          <TextField
            label={t('calculatorView.tripsCalculator.carPassengersLabel')}
            name='carPassengers'
            type='number'
            placeholder='Enter number'
          />
        </div>
      </div>

      {/* 3. Your Hotel Stay */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.tripsCalculator.hotelStaySectionHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.tripsCalculator.hotelStaySectionParagraph')}</p>
        <div className={styles.inputGroup}>
          <DropDown
            label={t('calculatorView.tripsCalculator.hotelCountryLabel')}
            name='hotelCountry'
            option={countries}
          />
          <TextField
            label={t('calculatorView.tripsCalculator.starsLabel')}
            name='stars'
            type='number'
            placeholder='Enter number'
          />
        </div>
        <div className={styles.inputGroup}>
          <TextField
            label={t('calculatorView.tripsCalculator.roomsLabel')}
            name='rooms'
            type='number'
            placeholder='Enter number'
          />
          <TextField
            label={t('calculatorView.tripsCalculator.daysLabel')}
            name='days'
            type='number'
            placeholder='Enter number'
          />
        </div>
      </div>
    </form>
  );
};

export default TripsCalculator;
